"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tileset2D", {
  enumerable: true,
  get: function get() {
    return _tileset2d.Tileset2D;
  }
});
Object.defineProperty(exports, "STRATEGY_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _tileset2d.STRATEGY_DEFAULT;
  }
});
Object.defineProperty(exports, "Tile2DHeader", {
  enumerable: true,
  get: function get() {
    return _tile2dHeader.Tile2DHeader;
  }
});
Object.defineProperty(exports, "isGeoBoundingBox", {
  enumerable: true,
  get: function get() {
    return _utils.isGeoBoundingBox;
  }
});
Object.defineProperty(exports, "isURLTemplate", {
  enumerable: true,
  get: function get() {
    return _utils.isURLTemplate;
  }
});
Object.defineProperty(exports, "urlType", {
  enumerable: true,
  get: function get() {
    return _utils.urlType;
  }
});
Object.defineProperty(exports, "getURLFromTemplate", {
  enumerable: true,
  get: function get() {
    return _utils.getURLFromTemplate;
  }
});
Object.defineProperty(exports, "getTileIndices", {
  enumerable: true,
  get: function get() {
    return _utils.getTileIndices;
  }
});
Object.defineProperty(exports, "tileToBoundingBox", {
  enumerable: true,
  get: function get() {
    return _utils.tileToBoundingBox;
  }
});

var _tileset2d = require("./tileset-2d");

var _tile2dHeader = require("./tile-2d-header");

var _utils = require("./utils");
//# sourceMappingURL=index.js.map